export const CONFIGURE_DATA_ANONYMIZATION = {
    id: `oe.accountAdmin.configureDataAnonymization`,
    description: 'title text',
    defaultMessage: 'Configure Data Anonymization'
};

export const CONFIGURE_3RD_PARTY_REGISTRATION = {
    id: 'oe.accountAdmin.configure3rdPartyRegistration',
    description: 'title text',
    defaultMessage: 'Configure 3rd Party Registration'
};

export const CONFIGURE_ACCOUNT_SUBDOMAIN = {
    id: 'oe.accountAdmin.configureAccountSubdomain',
    description: 'title text',
    defaultMessage: 'Configure Account Subdomain'
};

export const CONFIGURE_RECURRING_MEETINGS = {
    id: 'oe.accountAdmin.configureRecurringZoomMeetings',
    description: 'title text',
    defaultMessage: 'Configure Recurring Meetings'
};

export const COMPLIANCE_EMAIL_CAPTURE = {
    id: 'oe.accountAdmin.complianceEmailCapture',
    description: 'title text',
    defaultMessage: 'Compliance Email Capture'
};

export const MANAGE_REGISTRATION_APPROVAL_VIA_API = {
    id: 'oe.accountAdmin.registrationApprovalViaAPI',
    description: 'title text',
    defaultMessage: 'Registration Approval via API'
};

export const MANAGE_ORDER_BOOKING = {
    id: 'oe.accountAdmin.manageOrderBooking',
    description: 'title text',
    defaultMessage: 'Configure Order Booking'
};

export const THIRDRD_PARTY_EVENT_REGISTRATION_STATUS_UPDATED_TEXT = {
    id: 'oe.accountAdmin.thirdrdPartyEventRegistrationStatusUpdated',
    description: 'Notification text',
    defaultMessage: '3rd Party Event Registration Data updated'
};

export const THIRDRD_PARTY_EVENT_REGISTRATION_STATUS_TEXT = {
    message: '3rd Party Event Registration is {suffix}',
    id: 'oe.accountAdmin.thirdrdPartyEventRegistrationStatus',
    description: 'Label text',
};

export const ANONYMIZATION_DATA_UPDATED_TEXT = {
    id: 'oe.websiteTab.anonymizationDataUpdated',
    description: 'Notification about updated anonymization data',
    defaultMessage: 'Anonymization Data updated'
};

export const ORDER_BOOKING_DATA_UPDATED_TEXT = {
    id: 'oe.websiteTab.orderBookingDataUpdated',
    description: 'Notification about updated order booking data',
    defaultMessage: 'Order Booking Data updated'
};

export const AUTOMATIC_DATA_ANONYMIZATION_STATUS_TEXT = {
    message: 'Automatic Data Anonymization is {suffix}',
    id: 'oe.accountAdmin.automaticDataAnonymizationStatus',
    description: 'Label text',
};

export const DAYS_COUNT_BEFORE_ANONYMIZATION_TEXT = {
    id: 'oe.accountAdmin.daysCountBeforeAnonymization',
    defaultMessage: 'days after the Event End Date',
    description: 'Label text',
};

export const RECURRING_ZOOM_MEETINGS_STATUS_UPDATED_TEXT = {
    id: 'oe.accountAdmin.recurringZoomMeetingsStatusUpdated',
    description: 'Notification text',
    defaultMessage: 'Recurring Zoom Meetings Data updated'
};

export const ADD_GROUPS_TEXT = {
    id: 'oe.accountAdmin.addGroups',
    description: 'Button text',
    defaultMessage: '{prefix}Add Groups',
};

export const EVENT_DATA_WILL_BE_ANONYMIZED_TEXT = {
    id: 'oe.accountAdmin.eventDataWillBeAnonymized',
    defaultMessage: 'Event Data will be anonymized',
    description: 'Label text',
};

export const ACCOUNT_ADMIN_SECTION_TEXT = {
    id: 'oe.common.accountAdmin',
    defaultMessage: 'Account Admin',
    description: 'Section header'
};

export const AUTOMATIC_DATA_ANONYMIZATION_TEXT = {
    id: 'oe.accountAdmin.automaticDataAnonymization',
    defaultMessage: 'Automatic Data Anonymization',
    description: 'Label text'
};

export const AUTOMATIC_DATA_STATUS_TEXT = {
    id: `oe.accountAdmin.automaticDataStatus`,
    defaultMessage: 'Automatic data anonymization is {suffix}.',
    description: 'Account Admin page empty text'
};

export const ACCOUNT_SUBDOMAIN_TEXT = {
    id: 'oe.accountAdmin.accountSubdomain',
    defaultMessage: 'Account Subdomain',
    description: 'Label text'
};

export const ACCOUNT_SUBDOMAIN_STATUS_TEXT = {
    id: `oe.accountAdmin.accountSubdomainStatus`,
    defaultMessage: 'Account Subdomain is {suffix}.',
    description: 'Account Subdomain status text'
};

export const THIRD_PARTY_EVENT_REGISTRATION_TEXT = {
    id: 'oe.accountAdmin.3rdPartyEventRegistration',
    defaultMessage: '3rd PARTY EVENT REGISTRATION',
    description: 'Label text'
};

export const THIRD_PARTY_EVENT_REGISTRATION_STATUS_TEXT = {
    id: `oe.accountAdmin.3rdPartyEventRegistrationStatus`,
    defaultMessage: '3rd Party Event Registration is {suffix}.',
    description: 'Label text'
};

export const RECURRING_ZOOM_MEETINGS_TEXT = {
    id: 'oe.accountAdmin.recurringZoomMeetings',
    defaultMessage: 'Recurring Zoom Meetings',
    description: 'Label text'
};

export const RECURRING_ZOOM_MEETINGS_STATUS_TEXT = {
    id: `oe.accountAdmin.recurringZoomMeetingsStatus`,
    defaultMessage: 'Recurring Zoom Meetings are {suffix}.',
    description: 'Label text'
};

export const COMPLIANCE_EMAILS_TEXT = {
    id: 'oe.accountAdmin.complianceEmails',
    defaultMessage: 'Compliance Emails',
    description: 'Label text'
};

export const INTERNAL_NOTIFICATION_EMAIL_TEXT = {
    id: 'oe.accountAdmin.internalNotificationEmails',
    defaultMessage: 'Internal Notification Email Recipients',
    description: 'Label text'
};

export const COMPLIANCE_EMAIL_STATUS_TEXT = {
    id: `oe.accountAdmin.complianceEmailStatus`,
    defaultMessage: 'Compliance Email is {suffix}.',
    description: 'Label text'
};

export const SEGREGATED_DATA_ENCRYPTION_STATUS_TEXT = {
    id: `oe.accountAdmin.segregatedDataEncryptionStatus`,
    defaultMessage: 'Segregated Data Encryption is {suffix}.',
    description: 'Label text'
};


export const SEGREGATED_DATA_ENCRYPTION_TOGGLE_TEXT = {
    message: 'Segregated Data Encryption is {suffix}',
    id: 'oe.accountAdmin.segregatedDataEncryptionToggleText',
    description: 'Label text',
};

export const SEGREGATED_DATA_ENCRYPTION_TEXT = {
    id: `oe.accountAdmin.segregatedDataEncryption`,
    defaultMessage: 'Segregated Data Encryption',
    description: 'Label text'
};

export const URL_PARAMETER_REGISTRATION_TEXT = {
    id: 'oe.accountAdmin.urlParameterRegistrations',
    defaultMessage: 'URL Parameter Registration',
    description: 'title text'
};

export const URL_PARAMETER_REGISTRATION_STATUS_TEXT = {
    id: `oe.accountAdmin.urlParameterRegistrationStatus`,
    defaultMessage: 'URL Parameter Registration is {suffix}.',
    description: 'Label text'
};

export const URL_PARAMETER_REGISTRATION_DATA_UPDATED_TEXT = {
    id: 'oe.websiteTab.urlParameterRegistrationDataUpdated',
    description: 'Notification about updated url Parameter Registration data',
    defaultMessage: 'URL Parameter Registration Data updated'
};

export const SEGREGATED_DATA_ENCRYPTION_UPDATED_TEXT = {
    id: 'oe.accountAdmin.segregatedDataEncryptionUpdated',
    description: 'Notification about updated segregated data data',
    defaultMessage: 'Segregated Data Encryption updated'
};

export const CONFIGURE_DATA_SEGREGATION_TEXT = {
    id: 'oe.accountAdmin.configureDataSegregation',
    description: 'Title text',
    defaultMessage: 'Configure Data Segregation'
};

export const SEGREGATED_DATA_ENCRYPTION_INFO_TEXT = {
    id: 'oe.accountAdmin.segregatedDataEncryptionInfo',
    description: 'Title text',
    defaultMessage: 'Segregated Data Encryption keeps customer data in {br} OE Central encrypted with a unique key that is not used to encrypt data in any other Account.'
};

export const SEGREGATED_DATA_ENCRYPTION_CLIENTS_INFO_TEXT = {
    id: 'oe.accountAdmin.segregatedDataEncryptionClientsInfo',
    description: 'Title text',
    defaultMessage: 'Segregated Data Encryption is only for clients who have a current subscription to a Data Security package. It should not be enabled for any clients without a subscription.'
};

export const ORDER_BOOKING_LABEL_TEXT = {
    id: 'oe.accountAdmin.orderBooking',
    defaultMessage: 'Order Booking',
    description: 'Label text',
};

export const ORDER_BOOKING_STATUS_TEXT = {
    id:'oe.accountAdmin.orderBookingStatusText',
    message: 'Order Booking is {suffix}',
    description: 'Label text',
};

export const MANAGE_ATTRIBUTES_TEXT = {
    id: 'oe.accountAdmin.manageAttributes',
    defaultMessage: 'Attributes',
    description: 'title text'
};

export const MANAGE_EVENT_ATTRIBUTES_TEXT = {
    id: `oe.accountAdmin.manageEventAttributes`,
    defaultMessage: 'Manage Event Attributes.',
    description: 'Label text'
};

export const SECURITY_AND_COMPLIANCE_SECTION_TEXT = {
    id: 'oe.accountAdmin.securityAndCompliance',
    defaultMessage: 'SECURITY & COMPLIANCE',
    description: 'Section header text'
};

export const INTEGRATION_SETTINGS_SECTION_TEXT = {
    id: 'oe.accountAdmin.integrationSettings',
    defaultMessage: 'INTEGRATION SETTINGS',
    description: 'Section header text'
};

export const FEATURES_SECTION_TEXT = {
    id: 'oe.accountAdmin.features',
    defaultMessage: 'FEATURES',
    description: 'Section header text'
};

export const ORDER_BOOKING_SECTION_TEXT = {
    id: 'oe.accountAdmin.orderBookingSection',
    defaultMessage: 'ORDER BOOKING',
    description: 'Section header text'
};

export const AI_WORKFLOW_TOOLS_TEXT = {
    id: 'oe.accountAdmin.aiWorkflowTools',
    defaultMessage: 'AI Workflow Tools',
    description: 'Label text'
};

export const AI_WORKFLOW_TOOLS_STATUS_TEXT = {
    id: `oe.accountAdmin.aiWorkflowToolsStatus`,
    defaultMessage: 'AI Workflow Tools are {suffix}.',
    description: 'Label text'
};

export const AI_AGENT_ACCESS_TEXT = {
    id: 'oe.accountAdmin.aiAgentAccess',
    defaultMessage: 'AI Agent Access',
    description: 'Label text'
};

export const AI_AGENT_ACCESS_STATUS_TEXT = {
    id: `oe.accountAdmin.aiAgentAccessStatus`,
    defaultMessage: 'AI Agent Access is {suffix}.',
    description: 'Label text'
};

export const CONFIGURE_AI_AGENT_ACCESS_TEXT = {
    id: 'oe.accountAdmin.configureAIAgentAccess',
    defaultMessage: 'Configure AI Agent Access',
    description: 'Title text'
};

export const AI_AGENT_ACCESS_TOGGLE_TEXT = {
    id: 'oe.accountAdmin.aiAgentAccessToggleText',
    message: 'AI Agent Access is {suffix}',
    description: 'Label text'
};

export const AI_AGENT_ACCESS_INFO_TEXT = {
    id: 'oe.accountAdmin.aiAgentAccessInfo',
    defaultMessage: 'AI Agent Access allows AI agents to access data within this account via the MCP Server.',
    description: 'Info text'
};

export const AI_AGENT_ACCESS_UPDATED_TEXT = {
    id: 'oe.accountAdmin.aiAgentAccessUpdated',
    defaultMessage: 'AI Agent Access updated',
    description: 'Notification about updated AI Agent Access data'
};

export const CONFIGURE_OE_PASSPORT_ATTENDEE_TEXT = {
    id: 'oe.accountAdmin.oePassportAttendee',
    defaultMessage: 'Configure OE Passport Attendee SSO',
    description: 'title text'
};

export const OE_PASSPORT_ATTENDEE_TEXT = {
    id: 'oe.accountAdmin.oePassportAttendee',
    defaultMessage: 'OE Passport Attendee SSO',
    description: 'title text'
};

export const OE_PASSPORT_ATTENDEE_STATUS_TEXT = {
    id: 'oe.accountAdmin.oePassportAttendeeStatusText',
    defaultMessage: 'OE Passport Attendee SSO is {suffix}',
    description: 'title text'
};

export const OE_PASSPORT_ATTENDEE_SSO_DATA_UPDATED_TEXT = {
    id: 'oe.websiteTab.oePassportAttendeeSSODataUpdated',
    description: 'Notification about updated OE Passport Attendee SSSO data',
    defaultMessage: 'OE Passport Attendee SSO Data updated'
};